export enum AiTranslationProgress {
  UNAVAILABLE,
  TRANSLATING,
  TRANSLATED,
  CANNOT_TRANSLATE,
}

export default AiTranslationProgress;
